<template>
  <el-dialog
    fullscreen
    :title="dialogTitle"
    v-loading.fullscreen.lock="drawSaving"
    element-loading-text="图片上传中，请稍后..."
    element-loading-background="rgba(0, 0, 0, 0.65)"
    custom-class="task-review-evidence-dialog dark"
    :before-close="handleBeforeClose"
    :close-on-click-modal="!drawSaving"
    :close-on-press-escape="!drawSaving"
    :visible.sync="visible"
    @closed="handleClosed">
    <div class="tred-container">
      <div class="tred-container-left">
        <view-image
          ref="viewImage"
          v-if="['photo', 'qrcode'].includes(type)"
          @label="onLabel"
          @labeled="onLabeled"
          @draw-saved="onDrawSaved"
          @draw-saving-change="onDrawSavingChange"
          :index="viewIndex"
          :files="files"
          :visible="visible"
          :toolbar="toolbar"
          :get-lable-data="getLableData"
          :order-id="orderDetail.orderid"/>
        <view-video v-if="type==='video'"
                    :index="viewIndex"
                    :files="files"
                    :visible="visible"/>
        <view-audio v-if="type==='record'"
                    :index="viewIndex"
                    :files="files"
                    :visible="visible"
                    :order-id="orderDetail.orderid"
                    :task-title="orderDetail.title"
                    @close="visible = false"
                    :isOpenThroughRecord="isOpenThroughRecord"/>
      </div>
      <div class="tred-container-right"
           v-perfect-scrollbar.relative="{suppressScrollX:true}">
        <!-- <h4 @click="consoleviewer">console.view</h4> -->
        <el-collapse v-model="activeNames">
          <el-collapse-item v-if="showAsrRiskPanel"
                            title="疑似违规风险"
                            name="asrRisk">
            <div class="asr-risk-panel">
              <template v-if="asrCheckFailed">
                <el-tag size="mini" type="info">检查失败</el-tag>
                <p v-if="asrCheckResult.fail_reason"
                   class="asr-risk-panel__reason">{{ asrCheckResult.fail_reason }}</p>
              </template>
              <template v-else-if="asrCheckRunning">
                <el-tag size="mini" type="info">检查中</el-tag>
              </template>
              <template v-else-if="asrCheckHasRisk">
                <div class="asr-risk-panel__status">
                  <el-tag size="mini" type="danger">已触发 {{ asrRiskItems.length }} 项</el-tag>
                </div>
                <div v-for="item in asrRiskItems"
                     :key="'asr-risk-panel-' + item.id"
                     class="asr-risk-panel__item"
                     @click="onRiskItemClick(item)">
                  <div class="asr-risk-panel__row">
                    <el-tag size="mini"
                            type="danger"
                            class="asr-risk-panel__alias">{{ item.alias || '风险项' }}</el-tag>
                    <span class="asr-risk-panel__meta">{{ riskSegmentCount(item) }} 处命中</span>
                  </div>
                  <el-tooltip v-if="riskSegmentPreview(item)"
                              effect="dark"
                              placement="left"
                              :open-delay="300"
                              :content="riskSegmentPreview(item).content || ''">
                    <div class="asr-risk-panel__seg"
                         @click.stop="onRiskSegmentClick(item, riskSegmentPreview(item))">
                      <span class="asr-risk-panel__time">{{ formatBeginMs(riskSegmentPreview(item).begin_ms) }}</span>
                      <span class="asr-risk-panel__text">{{ riskSegmentPreview(item).content || '跳转播放' }}</span>
                    </div>
                  </el-tooltip>
                  <div v-if="riskSegmentCount(item) > 1"
                       class="asr-risk-panel__more">
                    另有 {{ riskSegmentCount(item) - 1 }} 处，点击跳转首处
                  </div>
                </div>
              </template>
              <template v-else-if="asrCheckSuccess">
                <el-tag size="mini" type="success">未触发风险</el-tag>
              </template>
              <template v-else>
                <span class="asr-risk-panel__empty">暂无风险检查结果</span>
              </template>
            </div>
          </el-collapse-item>
          <el-collapse-item title="历史门头照"
                            name="marketPhotos"
                            v-if="showMarketPhoto && orderDetail.marketinfo">
            <div v-for="(src, index) in orderDetail.marketinfo.photos"
                 style="float: left;padding-right: 5px"
                 :key="index+src">
              <el-popover
                placement="left"
                trigger="hover">
                <img :src="src|ossHost(`?x-oss-process=image/resize,w_500,h_${magnifierHeight},limit_0`)"
                     :alt="src">
                <img slot="reference"
                     :src="src|ossHost('?x-oss-process=image/resize,w_120')"
                     :alt="src">
              </el-popover>
            </div>
          </el-collapse-item>
          <el-collapse-item v-if="products.length"
                            title="产品列表"
                            name="products">
            <el-radio-group
              class="product-list"
              v-model="selectedProductNumber"
              @change="changeProductNumber">
              <el-radio label=""
                        style="margin-left: 10px;">显示全部产品
              </el-radio>
              <template v-for="item in products">
                <el-tooltip
                  effect="dark"
                  :content="item.name + '(' +  item.number + ')'"
                  :open-delay="1000"
                  placement="top">
                  <el-radio :style="item.isMatch?'':'margin-left: 10px;'"
                            :border="item.isMatch"
                            :label="item.number">{{item.name}}
                  </el-radio>
                </el-tooltip>
              </template>
            </el-radio-group>
          </el-collapse-item>
          <el-collapse-item title="说明信息"
                            name="1">
            <div v-html="question.text"></div>
          </el-collapse-item>
          <el-collapse-item title="说明图片"
                            name="2">
            <div v-for="({src}, index) in question.images"
                 :key="index+src">
              <el-popover
                placement="left"
                trigger="hover">
                <img :src="src|ossHost(`?x-oss-process=image/resize,w_500,h_${magnifierHeight},limit_0`)"
                     :alt="src">
                <img slot="reference"
                     width="250"
                     :src="src|ossHost(imgUrlSuffix)"
                     :alt="src">
              </el-popover>
            </div>
          </el-collapse-item>
          <el-collapse-item v-if="question.exampleText"
                            title="示例信息"
                            name="3">
            <div v-html="question.exampleText"></div>
          </el-collapse-item>
          <el-collapse-item v-if="question.exampleImages"
                            title="示例图片"
                            name="4">
            <div v-for="({src}, index) in question.exampleImages"
                 :key="index+src">
              <el-popover
                placement="left"
                trigger="hover">
                <img :src="src|ossHost(`?x-oss-process=image/resize,w_500,h_${magnifierHeight},limit_0`)"
                     :alt="src">
                <img slot="reference"
                     width="250"
                     :src="src|ossHost(imgUrlSuffix)"
                     :alt="src">
              </el-popover>
            </div>
          </el-collapse-item>
        </el-collapse>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import stringSimilarity from '@/vendor/string-similarity'
import store from '@store'
import ViewImage from './ViewImage.vue'
import ViewVideo from './ViewVideo.vue'
import ViewAudio from './ViewAudio'
import LableResult from '../../LableResult'
import QuestionReview from '../../../question-review.js'

export default {
  mixins: [],
  components: {ViewAudio, ViewImage, ViewVideo},
  data () {
    return {
      type: null,
      viewIndex: 0,
      files: [],
      visible: false,
      question: {},
      questionIndex: 0,
      imgUrlSuffix: '?x-oss-process=image/resize,w_250',
      activeNames: ['asrRisk', '1', '2', 'marketPhotos'],
      toolbar: {},
      getLableData: Function.prototype,
      products: [],
      selectedProductNumber: '',
      magnifierHeight: document.body.clientHeight - 40,
      orderDetail: {},
      onClose: null,
      onDrawSavedFunc: null,
      drawSaving: false,
    }
  },
  computed: {
    dialogTitle () {
      const questionPart = `Q${this.questionIndex + 1} ${(this.question && this.question.title) || ''}`.trim()
      const orderid = this.orderDetail && this.orderDetail.orderid
      const taskTitle = (this.orderDetail && this.orderDetail.title) || ''
      if (!orderid && !taskTitle) {
        return questionPart
      }
      const orderPart = orderid ? `工单 ${orderid}` : ''
      const meta = [orderPart, taskTitle].filter(Boolean).join(' · ')
      return meta ? `${meta} · ${questionPart}` : questionPart
    },
    // Vue.extend 挂 body，直接读 store，避免依赖组件树注入
    asrCheckResult () {
      return (store.state.orderReview && store.state.orderReview.asrCheckResult) || null
    },
    showAsrRiskPanel () {
      return this.type === 'record' && !!this.asrCheckResult
    },
    asrCheckFailed () {
      const status = this.asrCheckResult && Number(this.asrCheckResult.status)
      return status === 3 || status === 7
    },
    asrCheckRunning () {
      const status = this.asrCheckResult && Number(this.asrCheckResult.status)
      return status === 1 || status === 2 || status === 4 || status === 5
    },
    asrCheckSuccess () {
      return this.asrCheckResult && Number(this.asrCheckResult.status) === 6
    },
    asrCheckHasRisk () {
      return this.asrCheckSuccess && Number(this.asrCheckResult.trigger_risk_status) === 1
    },
    asrRiskItems () {
      if (!this.asrCheckHasRisk || !Array.isArray(this.asrCheckResult.items)) {
        return []
      }
      return this.asrCheckResult.items.filter(item => Number(item.is_trigger_risk) === 1)
    },
    showMarketPhoto () {
      return _.startsWith(this.question.title, '【到达】')
    },
    isOpenThroughRecord () {
      if (this.orderDetail.templatejson) {
        const templatejson = JSON.parse(this.orderDetail.templatejson)
        return templatejson.through_record === '1'
      }
      return false
    },
  },
  watch: {
    visible (val) {
      if (!val) {
        this.drawSaving = false
      }
    },
  },
  created () {
    this.$nextTick(() => {})
  },
  mounted () {},
  destroyed () {},
  methods: {
    handleBeforeClose (done) {
      if (this.drawSaving) {
        this.$message.warning('图片上传中，请稍后再关闭')
        return
      }
      done()
    },
    handleClosed () {
      if (typeof this.onClose === 'function') {
        const cb = this.onClose
        this.onClose = null
        cb()
      }
    },
    onDrawSavingChange (saving) {
      this.drawSaving = !!saving
    },
    riskSegments (item) {
      return (item && Array.isArray(item.asr_segments)) ? item.asr_segments : []
    },
    riskSegmentCount (item) {
      return this.riskSegments(item).length
    },
    riskSegmentPreview (item) {
      const segments = this.riskSegments(item)
      return segments.length ? segments[0] : null
    },
    formatBeginMs (beginMs) {
      const ms = Number(beginMs) || 0
      const totalSec = Math.floor(ms / 1000)
      const min = Math.floor(totalSec / 60)
      const sec = totalSec % 60
      return `${min}:${sec < 10 ? '0' : ''}${sec}`
    },
    seekToSegment (item, seg) {
      if (!seg) {
        this.$message.info('该风险项无命中片段')
        return
      }
      store.commit('orderReview/SET_ASR_CHECK_SEEK', {
        recordUrl: seg.record_url || '',
        beginMs: Number(seg.begin_ms) || 0,
        alias: (item && item.alias) || '',
      })
    },
    onRiskItemClick (item) {
      const segments = this.riskSegments(item)
      this.seekToSegment(item, segments[0])
    },
    onRiskSegmentClick (item, seg) {
      this.seekToSegment(item, seg)
    },
    changeProductNumber (productNumber) {
      LableResult.changeProduct(productNumber)
    },
    onLabel () {
      this.activeNames = this.$options.data().activeNames
      this.products = []
    },
    onLabeled () {
      this.$nextTick(() => {
        this.selectedProductNumber = ''
        this.products = LableResult.getProducts().filter(o => o.total > 0)
        if (this.products.length) {
          this.activeNames.push('products')
          const activeProduct = (product) => {
            this.selectedProductNumber = product.number
            this.changeProductNumber(this.selectedProductNumber)
          }
          let productName = []
          for (let product of this.products) {
            // 尝试完全匹配
            if (this.question.title.includes(product.name)) {
              this.$set(product, 'isMatch', true)
              return activeProduct(product)
            }
            productName.push(product.name)
          }
          // 产品与题目标题匹配
          let matchProduct = stringSimilarity.findBestMatch(this.question.title, productName)
          if (matchProduct.bestMatch.rating > 0) {
            activeProduct(this.products[matchProduct.bestMatchIndex])
          }
        }
      })
    },
    onDrawSaved () {
      if (!this.question || !this.question.id) return
      QuestionReview().reviewNotPassed(this.question.id, '本题审核不通过，点开标注图片查看标记原因')
      if (typeof this.onDrawSavedFunc === 'function') {
        this.onDrawSavedFunc({
          question: this.question,
          message: '本题审核不通过，点开标注图片查看标记原因',
        })
      }
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss"
       scoped>
.product-list label {
  display: block;
  margin: 10px 0;
}

.asr-risk-panel {
  font-size: 12px;
  color: #606266;
  line-height: 1.4;

  &__status {
    margin-bottom: 8px;
  }

  &__reason,
  &__empty {
    margin: 8px 0 0;
    color: #909399;
  }

  &__item {
    margin-top: 6px;
    padding: 8px;
    background: #fef0f0;
    border-radius: 4px;
    cursor: pointer;

    &:hover {
      background: #fde2e2;
    }
  }

  &__row {
    display: flex;
    align-items: center;
    min-width: 0;
  }

  &__alias {
    flex: 0 1 auto;
    max-width: 140px;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &__meta {
    flex: 0 0 auto;
    margin-left: 8px;
    color: #909399;
    white-space: nowrap;
  }

  &__seg {
    display: flex;
    align-items: center;
    margin-top: 6px;
    min-width: 0;
    color: #409eff;
  }

  &__time {
    flex: 0 0 36px;
    color: #f56c6c;
    font-variant-numeric: tabular-nums;
  }

  &__text {
    flex: 1;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  &__more {
    margin-top: 4px;
    color: #c0c4cc;
    font-size: 11px;
  }
}
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/question-review/components/AnswerFileFullScreen/src/main.vue